import React from 'react';

import { FloorGameTierLabel } from '@pkg/types/app/floorGame';

import { Interior, StyledBackground } from './styles';

export interface BackgroundProps {
    tier?: FloorGameTierLabel;
}

export function Background({ tier = FloorGameTierLabel.Tier1 }: BackgroundProps) {
    return (
        <StyledBackground $tier={tier}>
            <Interior />
        </StyledBackground>
    );
}
